import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment-timezone';

import { timeSelected } from 'data_system/resource_portal/actions/experienceActions';
import {
  getAvailableTimes,
  getSelectedDate,
  getSelectedTime,
  getExperienceScheduleIsOnline,
  getResourceTimezone,
} from 'data_system/resource_portal/selectors';

import TimeSelector from 'ui_system/forms/TimeSelection/TimeSelector';

const TimeSlotsContainer = () => {
  const selectedDate = useSelector(getSelectedDate());
  const selectedTime = useSelector(getSelectedTime());
  const resourceTimezone = useSelector(getResourceTimezone);

  const availableTimes = useSelector(getAvailableTimes());
  const isOnline = useSelector(getExperienceScheduleIsOnline());
  const timeSelectorToggled = () => {};
  const dispatch = useDispatch();

  const shouldDisableOnlineTime = (time) => {
    const dateTime = moment.tz(
      `${selectedDate} ${time}`,
      'YYYYMMDD h:mm A',
      resourceTimezone
    );
    const earliestDateTime = moment().add(24, 'hours');

    return dateTime.isBefore(earliestDateTime);
  };

  return (
    <TimeSelector
      field={{ name: 'time', value: selectedTime }}
      times={availableTimes}
      handleSelected={(_name, value) => dispatch(timeSelected(value))}
      handleSelectorToggled={timeSelectorToggled}
      enableAllTimes={isOnline && selectedDate}
      shouldDisableTime={isOnline ? shouldDisableOnlineTime : null}
    />
  );
};

export default TimeSlotsContainer;
